import React, { Component } from 'react';
import '../../scss/components/App.scss';

import Base from './Base.tsx';

class App extends Component {
    render() {
        return (
            <Base />
        );
    }
}

export default App;